import { render, staticRenderFns } from "./certifica.vue?vue&type=template&id=ca503c1c&"
import script from "./certifica.vue?vue&type=script&lang=js&"
export * from "./certifica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports